import { Model } from "./model";

export class PosmSubitem extends Model {
    id: number;
    name: string;
    content?: string;
    quantity: number;
    type: string;
    is_other?: boolean;
    is_notMultiorder?: boolean;
    is_printable?: boolean;
    image: string;
    image_url: string;
    thumbnail: string;
    thumbnail_url: string;
    parent_type: string;
    parent_name: string;
    product_id?: number;
    product_name?: string;
    asked_quantity?: number;
}


// WEBPACK FOOTER //
// ./src/models/posm-subitem.model.ts